import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UsersComponent } from 'src/app/customer-modules/apolus/users/users.component';
import { StaticImageComponent } from 'src/app/customer-modules/apolus/shared/widgets/static-image/static-image.component';
import { SimplifiedTableComponent } from 'src/app/customer-modules/apolus/shared/widgets/simplified-table/simplified-table.component';
import { FormsModule } from '@angular/forms';
import { CommonCloudStudioModule, DashboardModule } from 'common-cloudstudio';
import { SharedModule } from 'src/app/customer-modules/apolus/shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@NgModule({
  imports: [  
    CommonModule,
    FormsModule,
    CommonCloudStudioModule,
    TooltipModule.forRoot(),
    DashboardModule,
    SharedModule
  ],
  declarations: [
    UsersComponent, 
  ],
  exports: [
    UsersComponent,
  ],
})
export class UsersModule {}
